import axiosInstance from "./api";

const getAllTags = async () => {
  const tags = await axiosInstance.get("/api/tags");
  if (!tags.data?.data?.length > 0) {
    return null;
  }
  return tags.data.data;
};

const createTag = async (tagName) => {
  const response = await axiosInstance.post("/api/tags", { name: tagName });
  return response.data.data;
}

const migrateTagsFromPrompts = async () => {
  const response = await axiosInstance.post("/api/tags/migrate");
  return response.data.data;
};


export const tagService = {
    getAllTags,
    createTag,
    migrateTagsFromPrompts,
}

export default tagService;
